import React from 'react';
import {
  default as MuiPaginationItem,
  type PaginationItemTypeMap as MuiPaginationItemTypeMap,
  type PaginationItemProps as MuiPaginationItemProps,
} from '@mui/material/PaginationItem';
import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';
import { DistributiveOmit } from '@mui/types';

/**
 * Props that we do not want to include with PaginationItem.
 *
 * Using `keyof Pick` provides type safety that ensures we are
 * only blocking props that are part of the interface.
 **/
type PaginationItemBlockedProps = keyof Pick<
  MuiPaginationItemProps,
  'color' | 'shape' | 'variant' | 'components'
>;

export interface PaginationItemTypeMap<
  // eslint-disable-next-line @typescript-eslint/ban-types
  AdditionalProps = {},
  RootComponent extends React.ElementType = MuiPaginationItemTypeMap['defaultComponent']
> {
  props: AdditionalProps &
    DistributiveOmit<MuiPaginationItemProps, PaginationItemBlockedProps>;
  defaultComponent: RootComponent;
}

export type PaginationItemProps<
  RootComponent extends React.ElementType = PaginationItemTypeMap['defaultComponent'],
  // eslint-disable-next-line @typescript-eslint/ban-types
  AdditionalProps = {}
> = OverrideProps<
  PaginationItemTypeMap<AdditionalProps, RootComponent>,
  RootComponent
> & {
  component?: React.ElementType;
};

export const PaginationItem: OverridableComponent<PaginationItemTypeMap> =
  MuiPaginationItem;
